import React from 'react';
import styled from 'styled-components';

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const Card = styled.div`
  background: linear-gradient(135deg, #0077B5 0%, #005885 100%);
  color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const CardLabel = styled.div`
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 400;
  opacity: 0.9;
  margin-bottom: 8px;
`;

const CardValue = styled.div`
  font-family: 'Segoe UI', sans-serif;
  font-size: 28px;
  font-weight: 700;
`;

/**
 * Summary Cards Component
 * @param {Array} cards - Array of card objects with {label: string, value: string|number}
 */
const SummaryCards = ({ cards = [] }) => {
  return (
    <CardsContainer>
      {cards.map((card, index) => (
        <Card key={index}>
          <CardLabel>{card.label}</CardLabel>
          <CardValue>{card.value?.toLocaleString ? card.value.toLocaleString() : card.value}</CardValue>
        </Card>
      ))}
    </CardsContainer>
  );
};

export default SummaryCards;


